import { handleApi } from "common/utils/handleApi";
import api, { baseApiService } from "shared/api";

export const getCompanies = async (includes = []) => {
  let url = baseApiService.ENDPOINTS.local_admin.companies;

  if (includes.length > 0) {
    url += "?include=" + includes.join(",");
  }

  return await handleApi(() => api.get(url));
};
